<template>
  <div>
    <h3>Motifs</h3>
    <div class="icon-list" v-bind:class="{ 'width-100': isWidth100}">
      <div v-for="motif in motifs" :key="motif.id" class="amsom-button"
           @click="setSelectedMotifAndRedirectToFormRecla(motif.id)">
        <button class="btn btn-primary">
          <i :class="fontawesomeico(motif.id)"></i>
        </button>
        <span class="amsom-button-libelle">{{ motif.libelle }}</span>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "Motifs",
  data() {
    return {
      selectedSollicitation: null,
    }
  },
  computed: {
    ...mapGetters('motifs', ['iCanWrite']),
    ...mapGetters('natures', ['selectedNature']),
    motifs() {
      return this.iCanWrite.filter(motif => motif.nature === this.selectedNature)
    },
    isWidth100() {
      if (this.motifs.length < 4) return true
      return false
    }
  },
  methods: {
    ...mapActions('motifs', ['setSelectedMotif']),
    ...mapActions('entrees', ['setSelectedEntree']),
    setSelectedMotifAndRedirectToFormRecla(motifID) {
      this.setSelectedMotif(motifID)
      this.$router.push({
        name: 'adresse',
        params: {sollicitation: this.selectedSollicitation}
      })
    },
    fontawesomeico(ID) {
      if (ID === "TECH") return 'fas fa-tools'
      return 'fas fa-cog'
    }
  },
  mounted: function () {
    if (typeof this.$route.params.sollicitation !== 'undefined' && this.$route.params.sollicitation !== null) {
      this.selectedSollicitation = this.$route.params.sollicitation
    }
    this.setSelectedMotif(null)
    this.setSelectedEntree(null)

    // if (this.motifs.length === 1){
    //   this.setSelectedMotif(this.motifs[0].id)
    //   this.$router.push({
    //     name: 'adresse',
    //     params: {sollicitation: this.selectedSollicitation}
    //   })
    // }
  }
}
</script>

<style scoped>


</style>